import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { TreeTableModule } from 'primeng/treetable';

import { HisCoreSharedModule } from '../core/his-core-shared.module';
import { HisStructureSharedModule } from '../structure/his-structure-shared.module';

import { HisTreeActionButtonsComponent } from './component/his-tree-action-buttons/his-tree-action-buttons.component';
import { HisTreeActionTemplateDirective } from './component/his-tree-action-buttons/his-tree-action-buttons.directive';
import { HisTreeCopyCutDirective } from './component/his-tree-action-buttons/his-tree-copy-cut.directive';
import { HisTreeSelectAutocompleteComponent } from './component/his-tree-select-autocomplete.component';
import { HisTreeSelectPopupComponent } from './component/his-tree-select-popup.component';
import { HisTreeSelectComponent } from './component/his-tree-select.component';

/**
 * SharedModule with tree components.
 */
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        HisTreeActionButtonsComponent,
        HisTreeActionTemplateDirective,
        HisTreeCopyCutDirective,

        // primeng
        DialogModule,
        TreeTableModule,
        AutoCompleteModule,
        DataViewModule,

        // HIS
        HisCoreSharedModule, // ui-pipe
        HisStructureSharedModule // plam
    ],

    declarations: [
        HisTreeSelectComponent,
        HisTreeSelectPopupComponent,
        HisTreeSelectAutocompleteComponent
    ],

    exports: [
        HisTreeSelectComponent,
        HisTreeSelectPopupComponent,
        HisTreeSelectAutocompleteComponent,
        HisTreeActionButtonsComponent,
        HisTreeActionTemplateDirective,
        HisTreeCopyCutDirective
    ]
    // NO PROVIDERS! Providers need to go into HisTreeCoreModule
})
export class HisTreeSharedModule { }
